<!--    
@author zhijie.huang
@date 2018/9/25
@version v1.1.0
@description 表格mixins组件

/**** 内置data对象 ****/
tlanKey
tData
tHead
tFun

/**** 内置method对象 ****/
// 初始化表格
tInitTable(data)
data = {
  lanName: string, // 多语言字段名
  head: array, // 表头字段数组，与多语言中对应的table字段对应
  headOpt: {}, // 表头配置（如果除了label和key还需定义要别的参数）
  requestFun: function // 请求方法，回传data
}

// 设置表头
tSetHead(arr, headOpt)
// 设置表方法
tSetFun(fun)
// 翻页方法
tCurrentChange(data)
// 单页容量改变方法
tSizeChange(data)
-->
<script>
export default {
  data () {
    return {
      tlanKey: '',
      tData: {},
      tHead: [],
      tFun: null,
      tPageInfo: {
        currentPage: 1,
        perPageCount: 10
      }
    }
  },
  methods: {
    tInitTable (data) {
      this.tlanKey = data.lanKey
      this.tSetHead(data.head, data.headOpt)
      this.tSetFun(data.requestFun)
    },
    tSetHead (arr, headOpt = null) {
      const head = []
      arr.map((item) => {
        const aHead = {
          key: item,
          label: this.$t(`${this.tlanKey}.${item}`),
          showOverflowTooltip: true
        }
        if (headOpt && headOpt[item]) {
          for (const key in headOpt[item]) {
            aHead[key] = headOpt[item][key]
          }
        }
        head.push(aHead)
      })
      this.tHead = head
    },
    tSetFun (fun) {
      if (fun && typeof fun === 'function') { this.tFun = fun }
    },
    tCurrentChange (data) {
      this.tFun && this.tFun({
        currentPage: this.tPageInfo.currentPage = data,
        perPageCount: this.tPageInfo.perPageCount
      })
    },
    tSizeChange (data) {
      this.tFun && this.tFun({
        currentPage: this.tPageInfo.currentPage,
        perPageCount: this.tPageInfo.perPageCount = data
      })
    },
    tResetPage () {
      this.tPageInfo.currentPage = 1
    }
  }
}
</script>
